import React from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { monthDisplayName } from "../../cxAwardMonth";

// The results table scrolls inside itself with its header pinned, like the import grid, rather
// than running the page on down the screen.
const GRID_MAX_HEIGHT = "50vh";

// Every message on screen is the one the backend returned for that row. A row that was skipped
// because the winner was already paid for the month says so in its own words, so nothing is
// silently dropped and nothing is reworded here.
const CxAddWinnersResults = ({ result, rows, onDone }) => {
     const results = result?.data?.results || result?.results || [];
     const total = result?.data?.total ?? result?.total ?? results.length;
     const succeeded = result?.data?.succeeded ?? result?.succeeded ?? 0;
     const failed = result?.data?.failed ?? result?.failed ?? 0;

     const data = results.map((row) => {
          const submitted = rows?.[row.rowIndex] || {};

          return {
               ...row,
               rowNumber: row.rowIndex + 1,
               name: `${submitted.firstName || ""} ${submitted.lastName || ""}`.trim(),
               monthName: monthDisplayName(row.month) || row.month || "",
               points: row.pointsCredited
                    ? Number(row.pointsCredited).toLocaleString()
                    : "",
               outcome: row.isSuccess ? "Added" : "Not added",
          };
     });

     return (
          <Box sx={{ pt: 2 }}>
               <Typography variant="h6" sx={{ mb: 1 }}>
                    {succeeded} of {total} added
                    {failed ? `, ${failed} not added` : ""}
               </Typography>

               <Grid
                    data={data}
                    className="sba-area-data-grid"
                    style={{ maxHeight: GRID_MAX_HEIGHT }}
               >
                    <GridColumn field="rowNumber" title="Row" width="90px" />
                    <GridColumn field="name" title="Winner" width="200px" />
                    <GridColumn field="email" title="Email" width="260px" />
                    <GridColumn field="monthName" title="Month" width="160px" />
                    <GridColumn field="points" title="Points" width="120px" />
                    <GridColumn field="outcome" title="Outcome" width="130px" />
                    <GridColumn field="message" title="Detail" width="420px" />
               </Grid>

               <Box sx={{ pt: 3 }}>
                    <Button type="button" themeColor="primary" onClick={onDone}>
                         Done
                    </Button>
               </Box>
          </Box>
     );
};

export default CxAddWinnersResults;
